exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-2acf1670]{padding:0 18px}.title-page[data-v-2acf1670]{color:#b8b5b5}.title .divider[data-v-2acf1670]{height:10px;background-color:#EBEEF5;border:none}.midButton[data-v-2acf1670]{width:240px;margin-top:8px}.linkFile[data-v-2acf1670]{color:gray}.linkFile[data-v-2acf1670]:hover{color:#0B5BAC}\n", ""]);

// exports
